import type { epicPullRequests } from "./model";

export interface Evidence {
  title: string; state: string; draft: boolean; approvals: number; changesRequested: number;
  prError: string | null; pipelineError: string | null; fetchedAt: string;
  pipelines: { id: number; name: string; status: string; result: string; url: string; currentRevision: boolean | null }[];
}

export function prEvidenceQuery(link: ReturnType<typeof epicPullRequests>[number]) {
  return {
    queryKey: ["board-pr", link.url],
    queryFn: async (): Promise<Evidence> => {
      const match = /\/_git\/([a-f\d-]+)\/pullrequest\/(\d+)$/i.exec(link.url);
      if (!match) throw new Error("Unsupported PR link");
      const response = await fetch(`/api/boards/pull-requests/${match[1]}/${match[2]}`, { signal: AbortSignal.timeout(95_000) });
      if (!response.ok) throw new Error("PR evidence unavailable");
      return response.json() as Promise<Evidence>;
    },
    staleTime: 60_000, refetchInterval: 60_000, retry: false,
  };
}
